export default __webpack_public_path__ + "static/media/A5.eb0a82f6.png";